/**
 * @package
 * @author Artem Ilinykh devsinglesly@gmail.com
 * @class Kladr
 */
import RestService from '@/modules/backend/RestService';
import { KladrQueryData } from '@/modules/backend/Dto/KladrQueryData';
import { plainToClass } from 'class-transformer';
import { KladrSubject } from '@/modules/backend/Entities/KladrSubject';

export class Kladr {
  private readonly rest: RestService;

  constructor(rest: RestService) {
    this.rest = rest;
  }

  public async query(data: KladrQueryData): Promise<KladrSubject[]> {
    const response = await this.rest.request('/api/v1/kladr/search', {
      method: 'GET',
      params: data
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return plainToClass<KladrSubject, any[]>(KladrSubject, response.data.result || []);
  }
}
